<template>
  <div class="layout">
    <img class="bg" :style="{transform:`translate(calc(-50% - ${moveX}px),0)`}" :src="`${$cdn}images/index_mask1.png`" alt="">
    <img class="bg" :style="{transform:`translate(calc(-50% - ${moveX*1.5}px),0)`}" :src="`${$cdn}images/index_mask2.png`" alt="">
    <img class="bg" :style="{transform:`translate(calc(-50% - ${moveX*3}px),0)`}" :src="`${$cdn}images/index_mask3.png`" alt="">
  </div>
</template>
<script>

export default {
  props:['moveX']
}
</script>

<style lang="less" scoped>
.layout{
  height: 100%;
  position: fixed;
  top: 0;
  width: calc(100% - 200px)!important;
  left: 0;
  .bg{
    width: 100%;
    bottom: 0;
    left: 50%;
    z-index: 0;
    position: fixed;
    user-select: none;
  }
}
</style>